<div class="modal-body">
  <div class="row">
    <div class="col">
      <h2 class="text-center mt-3">
        {{ 'feature-modal.introducing' | translate }}
        {{ title | async }}
      </h2>

      <div class="row">
        <div class="col-md-6 offset-md-3">
          <img src="./assets/img/{{ image }}" class="img-fluid pb-5 pt-3" />
        </div>
      </div>

      <p class="font-weight-bold mb-4">
        {{ intro | async }}
      </p>
      <p>{{ body | async }}</p>

      <div class="row cta mt-5" *ngIf="showCTA">
        <div class="col">
          <p class="font-weight-bold">
            <i>{{ 'feature-modal.cta.text' | translate }}</i>
          </p>
        </div>
        <div class="col-auto">
          <button
            class="btn btn-success"
            type="button"
            (click)="onOpenPlanList()"
          >
            {{ 'feature-modal.cta.button' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer" *ngIf="showClose">
  <button
    type="button"
    class="btn btn-outline-primary"
    (click)="activeModal.dismiss()"
  >
    {{ 'feature-modal.button.close' | translate }}
  </button>
</div>
